import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWarrantyTree } from "src/models/Products/WarrantyTree.models";

interface WarrantyTreeState {
  warrantyTrees: IWarrantyTree[];
  warrantyTreeToEdit: IWarrantyTree | null;
}

const initialState: WarrantyTreeState = {
  warrantyTrees: [],
  warrantyTreeToEdit: null,
};

const warrantyTreeSlice = createSlice({
  name: "WarrantyTree",
  initialState,
  reducers: {
    setWarrantyTreeList: (state, action: PayloadAction<IWarrantyTree[]>) => {
      state.warrantyTrees = action.payload;
    },
    concatListWarrantyTree: (
      state: WarrantyTreeState,
      action: PayloadAction<IWarrantyTree[]>
    ) => {
      state.warrantyTrees = [...state.warrantyTrees.concat(action.payload)];
    },
    setWarrantyTreeToEdit: (
      state,
      action: PayloadAction<IWarrantyTree | null>
    ) => {
      state.warrantyTreeToEdit = action.payload;
    },
    addWarrantyTree: (state, action: PayloadAction<IWarrantyTree>) => {
      state.warrantyTrees.push(action.payload);
    },
    updateWarrantyTree: (state, action: PayloadAction<IWarrantyTree>) => {
      let itemIndex = state.warrantyTrees.findIndex(
        item => item.warrantyTreeId === action.payload.warrantyTreeId
      );
      if (itemIndex !== -1) state.warrantyTrees[itemIndex] = action.payload;
    },
    deleteWarrantyTree: (state, action: PayloadAction<number>) => {
      const newArray = state.warrantyTrees.filter(
        item => item.warrantyTreeId !== action.payload
      );
      state.warrantyTrees = newArray;
    },
  },
});

export const {
  setWarrantyTreeList,
  concatListWarrantyTree,
  setWarrantyTreeToEdit,
  addWarrantyTree,
  updateWarrantyTree,
  deleteWarrantyTree,
} = warrantyTreeSlice.actions;

export default warrantyTreeSlice.reducer;
